/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersSteamOpenIdSteamOpenIdAuthData, FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersSteamOpenIdSteamOpenIdAuthDataFromJSONTyped, FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersSteamOpenIdSteamOpenIdAuthDataToJSON, } from './FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersSteamOpenIdSteamOpenIdAuthData';
export function FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestSteamOpenIdLoginFromJSON(json) {
    return FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestSteamOpenIdLoginFromJSONTyped(json, false);
}
export function FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestSteamOpenIdLoginFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersSteamOpenIdSteamOpenIdAuthData(json)) {
        return FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersSteamOpenIdSteamOpenIdAuthDataFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestSteamOpenIdLoginToJSON(json) {
    return FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestSteamOpenIdLoginToJSONTyped(json, false);
}
export function FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestSteamOpenIdLoginToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersSteamOpenIdSteamOpenIdAuthData(value)) {
        return FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersSteamOpenIdSteamOpenIdAuthDataToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestSteamOpenIdLogin.js.map